// generated by srcset-codegen
import src from "./loader-icon.svg";

const width = 22;
const height = 22;
export default { src, width, height };
